// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const statusApiFilesStatusGetParamsIdsMax = 10;

export const StatusApiFilesStatusGetParams = zod.object({
  "ids": zod.array(zod.uuid()).min(1).max(statusApiFilesStatusGetParamsIdsMax)
})

export type StatusApiFilesStatusGetParams = zod.input<typeof StatusApiFilesStatusGetParams>;
export type StatusApiFilesStatusGetParamsOutput = zod.output<typeof StatusApiFilesStatusGetParams>;
